import styled from 'react-emotion';

export const VideoWrapper = styled('video', { shouldForwardProp: prop => prop })`
  pointer-events: ${props => (props.controls ? 'all' : 'none')};
`;
